import React, { ReactNode, useContext, useMemo } from "react"

import AppStateContext from "../AppContent/AppStateContext"
import PostmateContext from "./postmateContext"
import { usePostmate } from "./usePostmate"

interface Props {
  children: ReactNode
  setSearchQuery: (query: string) => void
}

export const PostmateProvider = React.memo((props: Props) => {
  const { setServicesConfig } = useContext(AppStateContext)
  const { emit } = usePostmate({
    setSearchQuery: props.setSearchQuery,
    setServicesConfig: setServicesConfig,
  })

  const value = useMemo(() => ({ emit }), [emit])
  return (
    <PostmateContext.Provider value={value}>
      {props.children}
    </PostmateContext.Provider>
  )
})
